import React, { useState } from 'react';
import {
    Flex,
    ButtonGroup,
    ModalHeader,
    BlankModal,
    ModalFooter,
    ModalBody,
    Checkbox,
    Button,
} from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useAvailableColumns } from '../../../queues/hooks/use-available-columns';
import { useColumnDisplayNames } from '../../../queues/hooks/use-column-display-names';
import { useQueueStore } from '../../../queues/context/use-queue-store';

export const FrQueueColumnSelectModal = observer(function FrQueueColumnSelectModal({
    isOpen,
    onClose,
}: {
    isOpen: boolean;
    onClose: () => void;
}): React.ReactElement | null {
    const queueStore = useQueueStore();
    const columnDisplayNames = useColumnDisplayNames();
    const availableColumns = useAvailableColumns();

    const [selectedColumns, setSelectedColumns] = useState(() =>
        queueStore.workspacePanel.queue.queueColumns.reduce((acc, column) => {
            acc[column.columnDefinition] = true;
            return acc;
        }, {} as Record<string, boolean>)
    );

    return (
        <BlankModal
            data-testid="fr-queue-column-select-modal"
            size="md"
            onClose={onClose}
            isOpen={isOpen}
        >
            <ModalHeader>Select Columns</ModalHeader>
            <ModalBody>
                <ul
                    style={{
                        listStyleType: 'none',
                        padding: 0,
                        overflowY: 'auto',
                        height: '235px',
                    }}
                >
                    {availableColumns.map((column) => {
                        return (
                            <li key={column.name} style={{ padding: '0 0 10px 5px' }}>
                                <Checkbox
                                    isChecked={!!selectedColumns[column.name]}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setSelectedColumns((value) => ({
                                            ...value,
                                            [column.name]: e?.currentTarget?.checked,
                                        }));
                                    }}
                                >
                                    {columnDisplayNames[column.name].displayName}
                                </Checkbox>
                            </li>
                        );
                    })}
                </ul>
            </ModalBody>
            <ModalFooter>
                <Flex w="100%" justifyContent="flex-end">
                    <ButtonGroup>
                        <Button variant="ghost" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            variant="solid"
                            onClick={() => {
                                const columnsToDisplay = queueStore.workspacePanel.queue.availableColumns.filter(
                                    (column) => selectedColumns[column.name]
                                );
                                queueStore.workspacePanel.queue.updateColumns(
                                    columnsToDisplay.map((column) => ({
                                        ...column,
                                        columnDefinition: column.name,
                                    }))
                                );
                                onClose();
                            }}
                        >
                            Save
                        </Button>
                    </ButtonGroup>
                </Flex>
            </ModalFooter>
        </BlankModal>
    );
});
